import FiltersOrder from './FiltersOrder'
import FiltersQuery from './FiltersQuery'
import FilterCheckbox from './types/FilterCheckbox'

class Filters {
  constructor(form: HTMLFormElement) {
    new FiltersOrder(form)
    new FilterCheckbox(form)

    const FiltesQueryInstance = new FiltersQuery(form)
    FiltesQueryInstance.getPosts()
    FiltesQueryInstance.onInputChange(() => FiltesQueryInstance.getPosts())
  }
}

export default Filters
